/**
 * Options applied to every Highcharts chart through `provideHighcharts`.
 *
 * The palette is pinned to the light color scheme because BOSS has no dark mode, and Highcharts
 * would otherwise switch chart text, gridlines and tooltips to dark-mode colors whenever the
 * operating system prefers dark.
 */
export const HIGHCHARTS_GLOBAL_OPTIONS: Highcharts.Options = {
  lang: {
    thousandsSep: ',',
  },
  palette: {
    colorScheme: 'light',
  },
};
